var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergairLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 128,
    viewBox: "0 0 501 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_665_94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4824 111.787L39.6824 123.307C34.3491 121.173 29.6558 118.4 25.1758 114.987L36.4824 111.787Z",
    fill: "url(#paint0_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2149 91.52L13.2282 103.04C9.81487 98.56 7.04154 93.6533 4.9082 88.5333L16.2149 91.52Z",
    fill: "url(#paint1_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2117 95.7866L36.4784 111.787L24.9584 114.987C20.4784 111.573 16.4251 107.52 13.0117 103.253L15.9984 91.7333L32.2117 95.7866Z",
    fill: "url(#paint2_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6796 64L32.2129 95.7867L16.2129 91.52L23.6796 64Z",
    fill: "url(#paint3_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2133 36.48L23.68 64L16.2133 91.52L4.69333 88.32C1.70667 80.8533 0 72.5333 0 64C0 55.2533 1.70667 47.1466 4.90667 39.68L16.2133 36.48Z",
    fill: "url(#paint4_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2129 36.4799L32.2129 32.2133L23.6796 63.9999L16.2129 36.4799Z",
    fill: "url(#paint5_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2247 24.9598L16.2114 36.4798L4.69141 39.6798C7.03807 34.3465 9.81141 29.4398 13.2247 24.9598Z",
    fill: "url(#paint6_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4779 16.2132L32.2113 32.2132L16.2113 36.4799L13.2246 24.9599C16.6379 20.4799 20.6913 16.4266 24.9579 13.2266L36.4779 16.2132Z",
    fill: "url(#paint7_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.679 4.90674L36.479 16.4267L24.959 13.4401C29.439 9.81341 34.3457 7.04007 39.679 4.90674Z",
    fill: "url(#paint8_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9996 23.6799L32.2129 32.2133L36.4796 16.2133L63.9996 23.6799Z",
    fill: "url(#paint9_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.52 16.2133L95.7867 32.2133L64 23.6799L91.52 16.2133Z",
    fill: "url(#paint10_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.094 39.6798L111.574 36.4798L114.774 24.9598C118.188 29.4398 120.961 34.3465 123.094 39.6798Z",
    fill: "url(#paint11_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.775 24.9599L111.575 36.4799L95.5753 32.2132L91.3086 16.2132L102.829 13.2266C107.309 16.6399 111.362 20.6932 114.775 24.9599Z",
    fill: "url(#paint12_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.827 13.2267L91.3074 16.4267L88.1074 4.90674C93.6541 7.04007 98.5608 9.8134 102.827 13.2267Z",
    fill: "url(#paint13_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.574 36.4799L104.32 63.9999L95.7871 32.2133L111.574 36.4799Z",
    fill: "url(#paint14_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.094 39.68C126.294 47.1466 128 55.4666 128 64C128 72.5333 126.294 80.8533 123.094 88.32L111.574 91.3066L104.32 64L111.787 36.48L123.094 39.68Z",
    fill: "url(#paint15_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.787 91.52L95.7871 95.7867L104.32 64L111.787 91.52Z",
    fill: "url(#paint16_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.094 88.3201C120.96 93.6534 118.187 98.3467 114.774 102.827L111.787 91.3067L123.094 88.3201Z",
    fill: "url(#paint17_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.775 102.827C111.362 107.307 107.309 111.36 102.829 114.773L91.3086 111.787L95.5753 95.7867L111.575 91.52L114.775 102.827Z",
    fill: "url(#paint18_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5199 111.787L103.04 114.773C98.5599 118.187 93.6532 120.96 88.5332 123.093L91.5199 111.787Z",
    fill: "url(#paint19_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7867 95.7867L91.52 111.787L64 104.32L95.7867 95.7867Z",
    fill: "url(#paint20_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5185 111.787L88.5318 123.307C80.8518 126.293 72.5318 128 63.9985 128C55.2518 128 47.1452 126.293 39.6785 123.093L36.4785 111.573L63.9985 104.32L91.5185 111.787Z",
    fill: "url(#paint21_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9996 104.32L36.4796 111.787L32.2129 95.7867L63.9996 104.32Z",
    fill: "url(#paint22_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3185 4.90667L91.5185 16.4267L63.9985 23.68L36.4785 16.2133L39.6785 4.69333C47.1452 1.70667 55.2518 0 63.9985 0C72.5318 0 80.8518 1.70667 88.3185 4.90667Z",
    fill: "url(#paint23_linear_665_94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.213 41.8133C176.213 40.32 176.853 39.68 178.346 39.68H202.453C203.52 39.68 203.733 40.32 203.733 41.8133V42.88C203.733 44.3733 203.306 45.0133 202.453 45.0133H182.4V60.8H200.533C201.6 60.8 201.813 61.44 201.813 62.9333V64C201.813 65.4933 201.386 66.1333 200.533 66.1333H182.4V82.9867H202.666C203.733 82.9867 203.946 83.6267 203.946 85.12V86.1867C203.946 87.68 203.52 88.32 202.666 88.32H178.346C176.853 88.32 176.213 87.68 176.213 86.1867V41.8133ZM215.253 41.1733C215.253 40.1067 216.106 39.68 218.026 39.68H219.52C221.013 39.68 221.653 40.1067 222.506 40.96L244.48 74.24L246.613 78.08V41.1733C246.613 40.1067 247.466 39.68 249.386 39.68H249.813C251.733 39.68 252.586 40.32 252.586 41.1733V86.8267C252.586 87.8933 251.733 88.32 249.813 88.32H248.533C247.253 88.32 246.613 87.8933 246.186 87.2533L223.36 52.6933L221.44 49.0667V86.4C221.44 87.4667 220.586 87.8933 218.666 87.8933H218.24C216.32 87.8933 215.466 87.2533 215.466 86.4V41.1733H215.253ZM267.306 41.8133C267.306 40.32 267.946 39.68 269.44 39.68H293.546C294.613 39.68 294.826 40.32 294.826 41.8133V42.88C294.826 44.3733 294.4 45.0133 293.546 45.0133H273.493V60.8H291.626C292.693 60.8 292.906 61.44 292.906 62.9333V64C292.906 65.4933 292.48 66.1333 291.626 66.1333H273.493V82.9867H293.76C294.826 82.9867 295.04 83.6267 295.04 85.12V86.1867C295.04 87.68 294.613 88.32 293.76 88.32H269.44C267.946 88.32 267.306 87.68 267.306 86.1867V41.8133ZM306.773 41.8133C306.773 40.32 307.413 39.68 308.906 39.68H320.426C331.306 39.68 337.066 43.3067 337.066 51.84C337.066 57.8133 333.866 61.6533 329.173 63.5733V64C332.16 65.0667 333.653 68.0533 335.36 72.7467L340.693 86.4C340.906 86.8267 340.906 87.2533 340.906 87.4667C340.906 88.1067 340.053 88.5333 337.92 88.5333H337.28C336 88.5333 334.72 88.1067 334.506 87.4667L329.173 73.8133C327.04 68.48 324.266 66.9867 318.933 66.9867H312.746V86.8267C312.746 87.8933 311.893 88.32 309.973 88.32H309.333C307.413 88.32 306.56 87.68 306.56 86.8267V41.8133H306.773ZM321.92 61.6533C326.826 61.6533 330.88 57.8133 330.88 53.12C330.88 47.5733 327.04 45.0133 321.493 45.0133H312.746V61.6533H321.92ZM370.346 39.4667C377.173 39.4667 383.573 41.8133 383.573 43.7333C383.573 45.0133 382.08 47.7867 381.226 47.7867C380.373 47.7867 377.173 44.8 370.56 44.8C358.4 44.8 354.346 51.84 354.346 64C354.346 74.6667 357.546 83.6267 369.92 83.6267C373.546 83.6267 376.96 83.2 378.88 82.7733V68.6933H370.773C369.706 68.6933 369.493 68.0533 369.493 66.56V65.4933C369.493 64 369.92 63.36 370.773 63.36H382.933C384.426 63.36 385.066 64 385.066 65.4933V83.84C385.066 87.68 377.6 88.7467 369.706 88.7467C355.84 88.7467 348.373 81.0667 348.373 64.4267C347.946 47.1467 355.84 39.4667 370.346 39.4667Z",
    fill: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.386 85.5467L408.533 40.96C408.959 39.8933 410.453 39.4667 412.373 39.4667H415.999C417.919 39.4667 419.626 39.8933 419.839 40.96L434.986 85.5467C435.199 85.9733 435.199 86.4 435.199 86.8267C435.199 87.8933 434.133 88.32 431.786 88.32H428.799C426.879 88.32 425.173 87.8933 424.959 86.8267L422.186 78.2933H405.759L402.986 86.8267C402.559 87.8933 401.493 88.32 399.786 88.32H397.013C394.026 88.32 392.746 87.68 392.746 86.8267C392.959 86.6133 393.173 86.1867 393.386 85.5467ZM419.199 69.3333L415.359 56.96C414.933 56.1067 414.293 52.48 414.293 52.48H414.079C414.079 52.48 413.439 55.68 413.013 56.96L408.959 69.3333H419.199ZM442.239 41.8133C442.239 40.32 443.519 39.4667 446.293 39.4667H448.639C451.626 39.4667 452.693 40.32 452.693 41.8133V86.1867C452.693 87.68 451.413 88.5333 448.639 88.5333H446.293C443.306 88.5333 442.239 87.68 442.239 86.1867V41.8133ZM463.999 42.6667C463.999 40.7467 464.853 39.8933 466.773 39.8933H480.213C492.159 39.8933 497.493 44.5867 497.493 52.9067C497.493 58.24 494.079 62.08 489.386 64V64.2133C491.093 64.8533 493.226 67.6267 494.293 70.6133L500.479 85.76C500.693 86.4 500.906 86.8267 500.906 87.04C500.906 87.8933 499.626 88.32 496.853 88.32H494.079C492.159 88.32 490.453 87.8933 490.026 86.8267L484.479 73.3867C483.199 70.6133 481.919 69.3333 477.439 69.3333H474.666V86.1867C474.666 87.68 473.386 88.32 470.613 88.32H468.266C465.279 88.32 464.213 87.4667 464.213 86.1867V42.6667H463.999ZM481.279 60.16C484.053 60.16 486.613 57.6 486.613 54.1867C486.613 50.9867 484.479 48.8533 480.853 48.8533H474.666V60.16H481.279Z",
    fill: "#782476"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_665_94",
    x1: 32.1752,
    y1: 126.566,
    x2: 32.5827,
    y2: 106.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_665_94",
    x1: 0.453802,
    y1: 99.7781,
    x2: 21.6399,
    y2: 89.5915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6466AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#782476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_665_94",
    x1: 17.7691,
    y1: 89.4783,
    x2: 32.9584,
    y2: 119.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6466AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#782476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_665_94",
    x1: 12.7804,
    y1: 79.8933,
    x2: 36.0038,
    y2: 79.8933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6466AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#782476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_665_94",
    x1: 5.504,
    y1: 101.212,
    x2: 20.5781,
    y2: 6.68798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6466AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#782476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_665_94",
    x1: 23.3318,
    y1: 30.1247,
    x2: 31.0737,
    y2: 65.9775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6466AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#782476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_665_94",
    x1: -4.15979,
    y1: 31.7204,
    x2: 30.0631,
    y2: 33.3502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6466AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#782476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_665_94",
    x1: 32.9857,
    y1: 9.99456,
    x2: 13.0198,
    y2: 46.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6466AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#782476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_665_94",
    x1: 33.2854,
    y1: 2.47474,
    x2: 30.8406,
    y2: 19.1809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_665_94",
    x1: 24.8017,
    y1: 22.9183,
    x2: 76.5457,
    y2: 30.2506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6466AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#782476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_665_94",
    x1: 77.7835,
    y1: 18.321,
    x2: 81.0432,
    y2: 33.3951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_665_94",
    x1: 118.576,
    y1: 32.2537,
    x2: 132.02,
    y2: 35.5134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_665_94",
    x1: 113.538,
    y1: 17.4463,
    x2: 93.9817,
    y2: 32.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_665_94",
    x1: 98.2088,
    y1: 17.4166,
    x2: 93.7266,
    y2: 5.60007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_665_94",
    x1: 100.237,
    y1: 65.073,
    x2: 104.719,
    y2: 25.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6466AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#782476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_665_94",
    x1: 100.785,
    y1: 64,
    x2: 141.937,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6466AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#782476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_665_94",
    x1: 110.057,
    y1: 99.7525,
    x2: 91.7231,
    y2: 63.4923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6466AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#782476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_665_94",
    x1: 111.501,
    y1: 96.7787,
    x2: 122.503,
    y2: 95.1489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_665_94",
    x1: 93.5657,
    y1: 106.675,
    x2: 118.826,
    y2: 100.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_665_94",
    x1: 100.128,
    y1: 127.343,
    x2: 91.1636,
    y2: 110.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_665_94",
    x1: 85.9029,
    y1: 94.1313,
    x2: 76.5312,
    y2: 110.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_665_94",
    x1: 84.0817,
    y1: 117.199,
    x2: 35.19,
    y2: 114.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_665_94",
    x1: 49.0086,
    y1: 112.555,
    x2: 47.5388,
    y2: 91.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6466AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#782476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_665_94",
    x1: 36.3228,
    y1: 12.4245,
    x2: 94.9937,
    y2: 11.2043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_665_94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500.693,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergairLogo);
export default __webpack_public_path__ + "static/media/energair_logo.95ca8425d6ecc53715ab8a6805a3b344.svg";
export { ForwardRef as ReactComponent };